import { render, staticRenderFns } from "./BYYNGYWP.vue?vue&type=template&id=511a5fce&scoped=true"
import script from "./BYYNGYWP.vue?vue&type=script&lang=js"
export * from "./BYYNGYWP.vue?vue&type=script&lang=js"
import style0 from "./BYYNGYWP.vue?vue&type=style&index=0&id=511a5fce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511a5fce",
  null
  
)

export default component.exports